
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { CandidateItem } from "@/lib/model/exambuilder/exam-component/candidate";

@Component({
  components: {}
})
export default class AddCandidateTags extends Vue {
  @Prop() selectedItem!: CandidateItem;
  @Prop() selectedIdList!: number[];
  @Prop({ default: false }) visible!: boolean;
  @Prop() title!: string;
  @Prop() type!: string;

  isAllowNotice = 0;
  isSingle = true;

  created() {
    this.isSingle = this.selectedIdList.length <= 1;
    this.isAllowNotice =
      this.selectedIdList.length === 1 ? this.selectedItem.messageStatus : 1;
  }

  submit() {
    if (this.isSingle) {
      const env = this.title === "面试邀请通知" ? 0 : 1;
      CandidateItem.sendAsk(this.selectedItem.candidateId, env)
        .then((resp: any) => {
          if (resp.code === 0) {
            this.$message.success("通知已发送，结果可以在消息通知列表查看");
          } else {
            this.$message.error(resp.message);
          }
          this.sure();
          this.cancel();
        })
        .catch(() => {
          this.cancel();
        });
    } else {
      const env = this.title === "面试邀请通知" ? 0 : 1;
      CandidateItem.mSendAsk(this.selectedIdList, env)
        .then((resp: any) => {
          if (resp.code === 0) {
            this.$message.success("通知已发送，结果可以在消息通知列表查看");
          } else {
            this.$message.error(resp.message);
          }
          this.sure();
          this.cancel();
        })
        .catch(() => {
          this.cancel();
        });
    }
  }

  @Emit()
  cancel() {
    return true;
  }

  @Emit()
  sure() {
    return true;
  }
}
